export default __webpack_public_path__ + "static/media/roboto-latin-500italic.0d8bb5b3.woff2";